<template>
  <div class="invoice-apply">
    <el-form style="margin: auto;margin-top: 50px;" label-width="140px" :rules="rules">
      <!-- 发票类型 -->
      <el-form-item label="发票类型：" required>
        <select id="invoiceType" v-model="invoice_type">
          <option value="1">增值税专用发票</option>
          <option value="2">增值税普通发票</option>
        </select>
      </el-form-item>
      <el-form-item label="订单编号：" required>
        <select id="invoiceType" v-model="order_no">
          <option v-for="item in orderList" :key="item.order_no" :value="item.order_no">{{item.order_no}}</option>
        </select>
      </el-form-item>
      <!-- 发票抬头 -->
      <el-form-item label="发票抬头：" required>
        <input type="text" id="invoiceTitle" v-model="name" placeholder="请输入发票抬头" >
      </el-form-item>
      <el-form-item label="纳税人识别号：" required>
        <input type="text" id="taxNumber" v-model="taxNumber" placeholder="请输入纳税人识别号" >
      </el-form-item>
      <el-form-item label="开户行：" >
        <input type="text" id="openingBank" v-model="openingBank" placeholder="请输入开户行" >
      </el-form-item>
      <el-form-item label="银行账号：" >
        <input type="text" id="bankAccount" v-model="bankAccount" placeholder="请输入银行账号" >
      </el-form-item>
      <el-form-item label="地址：" >
        <input type="text" id="address" v-model="address" placeholder="请输入地址" >
      </el-form-item>
      <el-form-item label="联系电话：" required>
        <input type="text" id="phone" v-model="phone" placeholder="请输入联系电话" >
      </el-form-item>
      <el-form-item label="联系人：" >
        <input type="text" id="linkman" v-model="linkman" placeholder="请输入联系人" >
      </el-form-item>
      <el-form-item label="邮箱：" required>
        <input type="text" id="mailbox" v-model="mailbox" placeholder="请输入邮箱" >
      </el-form-item>
      <el-form-item label="备注：" >
        <input type="text" id="remark" v-model="remark" placeholder="请输入备注" >
      </el-form-item>
      
    </el-form>
    <!-- 提交按钮 -->
      <button :disabled="forbiddenSubmit" :class="forbiddenSubmit?'forbidden':''" @click="submit">提交申请</button>
  </div>
</template>

<script>
export default {
   name: '',
   components: {
   },
   mixins: [],
   props: {
     
   },
   data() {
     return {
       invoice_type: '',
       taxNumber: '',
       name: '',
       openingBank: '',
       bankAccount: '',
       address: '',
       phone: '',
       mailbox: '',
       linkman: '',
       remark: '',
       order_no: '',
       orderList: [],
     }
   },
   computed: {
     forbiddenSubmit(){
      if(this.invoice_type&&this.name&&this.taxNumber&&this.mailbox&&this.phone&&this.order_no){
        return false
      }else{
        return true
      }
     }
   },
   watch: {
     
   },
   mounted() {
    this.getPayment()
   },
   methods: {
    getPayment(){
      this.$http.get('/api/user/getUserPaymentOrder').then(res => {
        console.log(res, 'res')
        this.orderList = res;
      })
    },
    resetData(){
      this.invoice_type = '';
       this.taxNumber = '';
       this.name = '';
       this.openingBank = '';
       this.bankAccount ='';
       this.address ='';
       this.phone = '';
       this.mailbox = '';
       this.linkman ='';
       this.remark = '';
    },
     submit(){
      this.$http.post('/api/user/invoice',{
        invoice_type:this.invoice_type,
        taxNumber: this.taxNumber,
        name: this.name,
        phone: this.phone,
        mailbox: this.mailbox,
        address: this.address,
        linkman: this.linkman,
        remark: this.remark,
        openingBank: this.openingBank,
        bankAccount: this.bankAccount
      }).then(res => {
        if(res){
          this.$message.success('申请已提交')
          this.resetData()
        }
      })
     },
   }
};
</script>

<style lang=scss scoped>
::v-deep .el-form-item{
  width: 49%;
  display: inline-block;
  vertical-align: top;
}
.invoice-apply{
    background: #fff;
    padding: 10px;
    box-sizing: border-box;height: 100%;
}
.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}

input,
select {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}

button {
  padding: 10px 20px;
  background-color: #285492;
  color: white;
  border: none;
  cursor: pointer;
  margin: auto;
  display: block;
}

button:hover {
  background-color: #0056b3;
}
.forbidden{
  background-color: grey !important;
  cursor: not-allowed !important;
}
.forbidden:hover {
  background-color: grey !important;
}
</style>